export const REST_API = 'REST_API';

export const GET = 'get';
export const PUT = 'put';
export const POST = 'post';
export const DELETE = 'delete';
export const PATCH = 'PATCH';
export const REST_API_ERROR = 'REST_API_ERROR';
